module.exports = __webpack_public_path__ + "img/23.5b6aa673.jpg";